export type UniversityStaffRole = "DIRECTOR" | "STAFF";

export type UniversityStaffMember = {
  id: string;
  role: UniversityStaffRole;
  createdAt: string;
  updatedAt: string;
  user: {
    id: string;
    name: string;
    email?: string | null;
    photo?: string | null;
  };
};

export type UniversityStaffQuery = {
  universities: Array<{
    id: string;
    legacyId: string;
    name: string;
    universityStaff: UniversityStaffMember[];
  }>;
};

export type CreateUniversityStaffResponse = {
  createUniversityStaff: {
    success: boolean;
    message: string;
    universityStaff?: UniversityStaffMember | null;
  };
};

export type CreateUniversityStaffVariables = {
  input: {
    universityId: string;
    userId: string;
    role: UniversityStaffRole;
  };
};

export type UpdateUniversityStaffResponse = {
  updateUniversityStaff: {
    success: boolean;
    message: string;
    universityStaff?: UniversityStaffMember | null;
  };
};

export type UpdateUniversityStaffVariables = {
  input: {
    id: string;
    role: UniversityStaffRole;
  };
};

export type DeleteUniversityStaffResponse = {
  deleteUniversityStaff: {
    success: boolean;
    message: string;
  };
};

export type DeleteUniversityStaffVariables = {
  id: string;
};

export const UNIVERSITY_STAFF_ROLE_LABELS: Record<UniversityStaffRole, string> = {
  DIRECTOR: "Director",
  STAFF: "Staff"
};
